import { UserCog, LogOut } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { adminApi } from '../lib/api';

/**
 * Global banner shown when an admin is impersonating another account.
 * Provides a single button to return to the admin session.
 * Positioned as a sticky bar at the top of the viewport.
 */
export default function ImpersonationBanner() {
  const { impersonation, stopImpersonation } = useAuth();

  if (!impersonation) return null;

  const handleReturn = async () => {
    // Fire the audit-end call BEFORE clearing local state so we still have
    // the impersonated token available for the request (some deployments
    // rely on it to authenticate). Fire-and-forget: if it fails we still
    // return the admin to their session.
    const sid = impersonation.session_id || localStorage.getItem('gardenbook_imp_session');
    if (sid) {
      try { await adminApi.endImpersonation(sid); } catch { /* ignore */ }
    }
    stopImpersonation();
    window.location.replace('/admin');
  };

  return (
    <div
      className="sticky top-0 z-[70] flex items-center justify-between gap-3 px-4 py-2 bg-amber-500 text-amber-950 shadow-md text-sm"
      data-testid="impersonation-banner"
    >
      <div className="flex items-center gap-2 min-w-0">
        <UserCog className="w-4 h-4 flex-shrink-0" />
        <span className="truncate">
          Mode <strong>“Voir en tant que”</strong> — vous êtes connecté(e) comme <strong>{impersonation.target_name}</strong>
        </span>
      </div>
      <button
        onClick={handleReturn}
        className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-amber-950 text-amber-50 hover:bg-black transition-colors font-medium flex-shrink-0"
        data-testid="stop-impersonation-btn"
      >
        <LogOut className="w-3.5 h-3.5" />
        Retour admin
      </button>
    </div>
  );
}
